/**
 * Функции для проверки данных
 * @packageDocumentation
 */

import { toPuny } from '@/core/utils/url';

/**
 * Получить строку с регулярным выражением для домена
 *
 * Разрешена только латиница, в том числе пуни-код
 *
 * Строгая проверка на корректность домена должна происходить в API
 */
export const getDomainRegexp = (): string => {
	return `(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+(xn--)?(?:[\\w-]+)\\/?`;
};

/**
 * Проверка валидности email
 * @param email
 * @param rus_allow - если true, русскоязычные адреса тоже будут валидны
 */
export const isEmail = (email: string, rus_allow: boolean = false): boolean => {
	email += '';

	email = email.toLowerCase();

	let emailTest = '^[-0-9a-z_\\.\\+]+@([-0-9a-z_^\\.]+\\.)+[a-z]{2,20}$';

	if (rus_allow) {
		emailTest = '^[-0-9a-zа-яё_\\.\\+]+@([-0-9a-zа-яё_^\\.]+\\.)+[a-zа-яё]{2,20}$';
	}

	const regex = new RegExp(emailTest);
	return regex.test(email);
};

/**
 * Проверка валидности URL-адреса
 */
export const validUrl = (url: string, allowIP = false): boolean => {
	url = url.trim();
	if (url.includes(' ')) {
		return false;
	}

	const domain = url.replace(/^(https?:\/\/)?(www\.)?([^/]+).*/, '$3');

	if (allowIP && isIp(domain)) return true;

	return isDomain(domain);
};

/**
 * Проверка валидности домена
 */
export const isDomain = (domain: string): boolean => {
	domain = toPuny(domain);

	const regexp = new RegExp(`^${getDomainRegexp()}$`, 'u');

	return regexp.test(domain);
};

/**
 * Проверка валидности ip
 */
export const isIp = (ip: string): boolean => {
	const regexp = new RegExp('((^\\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\\s*$)|(^\\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:)(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))(%.+)?\\s*$))');

	return regexp.test(ip);
};
